import { useToast } from '../contexts/ToastContext';

export default useToast;
